import type { NewsItem } from "@/types/content";

export const newsItems: NewsItem[] = [
  {
    id: "n1",
    title: "美联储降息预期升温 国际金价重返2650美元上方",
    author: "周慕云",
    date: "2026-10-12",
    category: "市场分析",
    summary:
      "随着最新通胀与就业数据低于预期，市场对年内进一步降息的定价明显升温，美元指数走弱，国际现货黄金重返2650美元上方。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20financial%20editorial%20illustration%20of%20rising%20gold%20price%20and%20falling%20dollar%20index%2C%20deep%20navy%20background%20with%20glowing%20golden%20candlestick%20chart%20ascending%2C%20soft%20bokeh%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=800&height=500&seq=news-cover-01&orientation=landscape",
    tags: ["美联储", "降息预期", "国际金价"],
    views: 18420,
    likes: 326,
    readMinutes: 5,
    content: [
      {
        type: "paragraph",
        text: "本周国际现货黄金延续强势，重返每盎司2650美元上方。最新公布的通胀与就业数据双双低于市场预期，使得投资者对年内进一步降息的定价明显升温，美元指数与美债收益率同步回落，为无息资产黄金提供了有力支撑。",
      },
      { type: "heading", text: "降息预期如何传导至金价" },
      {
        type: "paragraph",
        text: "从定价逻辑看，实际利率是黄金最核心的估值锚。当市场预期名义利率下行而通胀保持黏性时，实际利率走低，持有黄金的机会成本随之下降，资金便倾向于增配黄金。本轮行情中，利率期货市场隐含的年内降息幅度已经上调，直接点燃了贵金属板块的做多情绪。",
      },
      {
        type: "quote",
        text: "在流动性预期转向宽松的阶段，黄金往往兼具避险与抗通胀的双重属性，中长期配置价值凸显。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Elegant%20financial%20data%20visualization%20of%20gold%20price%20trend%20line%20against%20deep%20blue%20gradient%20background%2C%20warm%20golden%20glow%2C%20stock%20market%20charts%2C%20professional%20editorial%20style%2C%20clean%20and%20minimal&width=800&height=460&seq=news-inline-01&orientation=landscape",
        caption: "国际现货黄金近日走势（演示数据）",
      },
      { type: "heading", text: "后市关注要点" },
      {
        type: "paragraph",
        text: "短期来看，市场焦点将转向下周公布的通胀数据与央行官员表态。若数据继续偏弱，金价有望挑战前高；若数据意外强劲，则可能引发获利了结带来的技术性回调。投资者应保持仓位弹性，避免在情绪高点追高。",
      },
    ],
    relatedNewsIds: ["n5", "n9", "n4"],
    relatedPriceIds: ["london-gold", "comex-gold", "au9999"],
  },
  {
    id: "n2",
    title: "震荡市如何布局黄金？三类投资工具优劣全解析",
    author: "陈砚秋",
    date: "2026-10-11",
    category: "投资策略",
    summary:
      "实物金、账户金与黄金基金各有侧重。本文从流动性、成本与风险承受度三个维度，帮助普通投资者找到适合自己的黄金配置方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20illustration%20of%20gold%20investment%20portfolio%20comparison%2C%20gold%20bars%20and%20coins%20on%20deep%20navy%20surface%20with%20soft%20golden%20light%2C%20minimal%20elegant%20financial%20style%2C%20high%20detail%20composition&width=800&height=500&seq=news-cover-02&orientation=landscape",
    tags: ["投资策略", "资产配置", "工具对比"],
    views: 15260,
    likes: 402,
    readMinutes: 6,
    content: [
      {
        type: "paragraph",
        text: "在黄金投资中，选择合适的工具往往比判断短期涨跌更为重要。不同工具体现出差异明显的流动性、交易成本与风险特征，投资者应结合自身的资金规模、投资期限与风险承受能力进行选择。",
      },
      { type: "heading", text: "实物黄金：看得见的安心" },
      {
        type: "paragraph",
        text: "金条、金币等实物黄金适合以保值为目标的长期持有者。其优势在于资产真实可感、无交易对手风险；不足之处在于买卖价差较大、变现相对不便，且需要考虑保管成本。",
      },
      { type: "heading", text: "账户金与纸黄金：便捷而灵活" },
      {
        type: "paragraph",
        text: "银行账户金与纸黄金交易门槛低、无杠杆、随时可买卖，净值紧密跟随国际金价，适合以资产配置为目的的稳健投资者。由于不带杠杆，其收益与风险都相对温和。",
      },
      { type: "heading", text: "黄金基金与期货：进阶之选" },
      {
        type: "paragraph",
        text: "黄金ETF联接基金适合定投，而黄金期货与T+D带有杠杆，波动被放大，更适合具备一定经验与风险承受能力的进阶投资者。参与前应充分了解保证金与强平规则。",
      },
      {
        type: "quote",
        text: "没有最好的工具，只有最适合自己的工具。先明确投资目标，再选择产品。",
      },
    ],
    relatedNewsIds: ["n6", "n1", "n7"],
    relatedPriceIds: ["paper-gold", "gold-td", "shfe-au"],
  },
  {
    id: "n3",
    title: "央行连续增持黄金 官方储备数据释放哪些信号",
    author: "林致远",
    date: "2026-10-10",
    category: "政策法规",
    summary:
      "最新官方储备数据显示，全球央行连续多个月增持黄金，储备结构持续多元化，为金价提供中长期底部支撑。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20illustration%20of%20central%20bank%20gold%20reserves%2C%20stacks%20of%20gold%20bars%20in%20a%20vault%20with%20deep%20navy%20tones%20and%20golden%20rim%20light%2C%20authoritative%20financial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-03&orientation=landscape",
    tags: ["央行购金", "官方储备", "中长期支撑"],
    views: 12980,
    likes: 288,
    readMinutes: 5,
    content: [
      {
        type: "paragraph",
        text: "全球央行持续增持黄金的动向，已成为近年来影响金价的重要结构性力量。官方储备数据显示，多个经济体连续数月增加黄金持仓，储备资产多元化趋势清晰。",
      },
      { type: "heading", text: "为何央行青睐黄金" },
      {
        type: "paragraph",
        text: "黄金不依赖任何单一主权信用，在储备资产中具有独特的稳定性。在全球货币环境不确定性上升的背景下，增加黄金配置有助于降低储备组合的整体波动。",
      },
      { type: "heading", text: "对普通投资者的启示" },
      {
        type: "paragraph",
        text: "央行的持续买入为金价提供了较为稳固的中长期底部支撑，但这并不意味着金价只涨不跌。普通投资者应关注官方持仓变化的方向与节奏，把它作为长期配置的参考信号而非短期交易依据。",
      },
    ],
    relatedNewsIds: ["n9", "n7", "n5"],
    relatedPriceIds: ["au9999", "shfe-au-next", "london-gold"],
  },
  {
    id: "n4",
    title: "地缘风险再起 避险资金为何加速涌入黄金",
    author: "苏晚晴",
    date: "2026-10-09",
    category: "热点解读",
    summary:
      "近期地缘局势扰动加剧，避险情绪升温，黄金与美债同步走强。本文解析避险资金流向黄金的传导链条。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20of%20safe%20haven%20gold%20amid%20geopolitical%20uncertainty%2C%20glowing%20golden%20light%20rays%20over%20deep%20navy%20world%20map%2C%20minimal%20professional%20financial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-04&orientation=landscape",
    tags: ["地缘风险", "避险情绪", "资金流向"],
    views: 16740,
    likes: 356,
    readMinutes: 4,
    content: [
      {
        type: "paragraph",
        text: "当地缘局势出现扰动时，市场风险偏好往往快速下降，资金会从风险资产流向传统的避险资产。黄金凭借悠久的历史公信力，通常是最先受益的品种之一。",
      },
      { type: "heading", text: "避险买盘的传导链条" },
      {
        type: "paragraph",
        text: "避险资金涌入黄金的路径大致为：风险事件发生→股票等风险资产承压→资金转向美债与黄金→金价获得短期买盘支撑。这一过程往往迅速而集中，容易造成金价短线跳涨。",
      },
      {
        type: "quote",
        text: "避险行情来得快、去得也快，投资者需理性区分情绪性冲高与趋势性上涨。",
      },
      {
        type: "paragraph",
        text: "需要提醒的是，地缘事件对金价的影响多为脉冲式。若事件未进一步升级，避险溢价可能逐步回吐。投资者应结合基本面判断行情性质，避免情绪化追高。",
      },
    ],
    relatedNewsIds: ["n1", "n5", "n2"],
    relatedPriceIds: ["london-gold", "comex-gold-cont", "gold-td"],
  },
  {
    id: "n5",
    title: "三季度金价回顾：新高之后的结构性机会",
    author: "周慕云",
    date: "2026-10-08",
    category: "市场分析",
    summary:
      "三季度国际金价多次刷新阶段高点，板块内部呈现明显的结构性分化。本文复盘行情脉络并展望四季度机会。",
    cover:
      "https://readdy.ai/api/search-image?query=Quarterly%20gold%20price%20review%20editorial%20illustration%2C%20ascending%20golden%20candlestick%20charts%20on%20deep%20navy%20background%2C%20soft%20warm%20glow%2C%20minimal%20professional%20financial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-05&orientation=landscape",
    tags: ["季度回顾", "结构性机会", "行情复盘"],
    views: 11350,
    likes: 244,
    readMinutes: 6,
    content: [
      {
        type: "paragraph",
        text: "回顾三季度，国际金价在多重因素推动下多次刷新阶段高点。降息预期、央行购金以及避险需求共同构成上涨的三重驱动，行情整体呈现震荡上行的格局。",
      },
      { type: "heading", text: "行情脉络复盘" },
      {
        type: "paragraph",
        text: "季度初期金价以区间整理为主，随后在利率预期转向与避险情绪推动下突破关键阻力，中期高位震荡，季度末再度获得买盘支撑。整体波动率较上季度明显抬升。",
      },
      { type: "heading", text: "结构性机会在哪里" },
      {
        type: "paragraph",
        text: "展望四季度，机会或将更多来自结构性而非全面性行情。美国实际利率走向、人民币汇率变化以及内外盘价差，都可能带来阶段性的交易窗口。投资者宜保持耐心，等待回调后的布局机会。",
      },
    ],
    relatedNewsIds: ["n1", "n9", "n8"],
    relatedPriceIds: ["london-gold", "comex-gold", "shfe-au"],
  },
  {
    id: "n6",
    title: "定投还是一次性买入 普通投资者黄金配置指南",
    author: "陈砚秋",
    date: "2026-10-07",
    category: "投资策略",
    summary:
      "面对金价的高位震荡，定投与一次性买入各有适用场景。本文用通俗的方式拆解两种策略的取舍逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20long%20term%20gold%20dollar%20cost%20averaging%20strategy%2C%20golden%20coins%20arranged%20along%20a%20rising%20path%20on%20deep%20navy%20background%2C%20warm%20soft%20light%2C%20minimal%20professional%20style&width=800&height=500&seq=news-cover-06&orientation=landscape",
    tags: ["定投", "配置指南", "成本控制"],
    views: 9840,
    likes: 312,
    readMinutes: 5,
    content: [
      {
        type: "paragraph",
        text: "在金价波动加大的环境中，买入方式的选择会显著影响投资体验。定投与一次性买入并非孰优孰劣，而是对应不同的资金性质与风险偏好。",
      },
      { type: "heading", text: "定投：用时间换成本" },
      {
        type: "paragraph",
        text: "定投通过规律买入摊薄成本，天然规避了择时难题，适合每月有稳定结余、追求长期配置的投资者。缺点是资金使用效率相对较低，难以在单边行情中充分获益。",
      },
      { type: "heading", text: "一次性买入：把握关键时点" },
      {
        type: "paragraph",
        text: "一次性买入适合资金到位且有明确择时判断的投资者。若判断准确，收益更为充分；但若买在阶段高点，也将承受更明显的回撤压力。",
      },
      {
        type: "quote",
        text: "对大多数普通投资者而言，定投是更容易长期坚持的黄金配置方式。",
      },
    ],
    relatedNewsIds: ["n2", "n7", "n3"],
    relatedPriceIds: ["paper-gold", "au9999", "shfe-au-next"],
  },
  {
    id: "n7",
    title: "黄金交易税收政策梳理 投资者需关注哪些要点",
    author: "林致远",
    date: "2026-10-06",
    category: "政策法规",
    summary:
      "不同黄金投资渠道在税收处理上存在差异，直接影响实际收益。本文梳理常见渠道的税务要点，帮助投资者算清成本账。",
    cover:
      "https://readdy.ai/api/search-image?query=Financial%20regulation%20and%20tax%20policy%20editorial%20illustration%2C%20golden%20documents%20and%20scales%20of%20justice%20on%20deep%20navy%20desk%2C%20warm%20golden%20accent%20light%2C%20minimal%20professional%20style&width=800&height=500&seq=news-cover-07&orientation=landscape",
    tags: ["税收政策", "交易成本", "合规"],
    views: 8420,
    likes: 176,
    readMinutes: 5,
    content: [
      {
        type: "paragraph",
        text: "黄金投资的实际收益不仅取决于价格变动，也与交易过程中的税费成本密切相关。不同投资渠道在税收处理上的差异，会直接影响投资者的到手回报。",
      },
      { type: "heading", text: "常见渠道的税务差异" },
      {
        type: "paragraph",
        text: "实物黄金、账户金、黄金基金与期货在增值税、所得税以及交易手续费上的处理各不相同。投资者在参与前应充分了解所在渠道的具体规则，避免因成本估算偏差影响收益预期。",
      },
      { type: "heading", text: "算清成本账的三点建议" },
      {
        type: "paragraph",
        text: "第一，关注买卖价差与手续费；第二，了解持有环节可能产生的费用；第三，通过正规渠道参与，确保交易与税务合规。清晰的成本认知，是理性投资的第一步。",
      },
    ],
    relatedNewsIds: ["n3", "n6", "n2"],
    relatedPriceIds: ["shfe-au-next", "paper-gold", "au9999"],
  },
  {
    id: "n8",
    title: "人民币金价与美元金价背离 背后的逻辑何在",
    author: "苏晚晴",
    date: "2026-10-05",
    category: "热点解读",
    summary:
      "近期内外盘金价出现阶段性背离，人民币汇率成为关键变量。本文解析汇率如何影响国内金价的实际涨幅。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20currency%20exchange%20rate%20impact%20on%20gold%20price%2C%20two%20glowing%20golden%20curves%20diverging%20on%20deep%20navy%20background%2C%20soft%20warm%20light%2C%20minimal%20professional%20financial%20style&width=800&height=500&seq=news-cover-08&orientation=landscape",
    tags: ["人民币汇率", "内外盘", "价差"],
    views: 10620,
    likes: 208,
    readMinutes: 4,
    content: [
      {
        type: "paragraph",
        text: "对于以人民币计价的黄金品种而言，其价格等于国际金价按汇率折算后的结果。因此，当人民币汇率波动时，国内金价的涨幅可能与美元金价出现阶段性背离。",
      },
      { type: "heading", text: "汇率是关键的传导变量" },
      {
        type: "paragraph",
        text: "当美元金价上涨而人民币同时升值时，人民币金价的涨幅会被部分抵消；反之，若人民币走弱，则可能放大国内金价的上涨幅度。理解这一机制，有助于投资者更准确地判断国内品种的真实强弱。",
      },
      {
        type: "paragraph",
        text: "对于同时关注内外盘的投资者而言，跟踪汇率变化、留意内外盘价差的回归规律，往往能发现更具性价比的参与时点。",
      },
    ],
    relatedNewsIds: ["n5", "n1", "n4"],
    relatedPriceIds: ["au9999", "shfe-au", "london-gold"],
  },
  {
    id: "n9",
    title: "机构展望：2026年黄金目标价上调至2800美元",
    author: "周慕云",
    date: "2026-10-04",
    category: "市场分析",
    summary:
      "多家研究机构在最新报告中上调了黄金的目标价，理由集中在降息周期、央行购金与地缘不确定性三大主线。",
    cover:
      "https://readdy.ai/api/search-image?query=Institutional%20gold%20price%20forecast%20editorial%20illustration%2C%20golden%20upward%20arrow%20and%20target%20chart%20on%20deep%20navy%20background%2C%20warm%20glowing%20accents%2C%20minimal%20professional%20financial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-09&orientation=landscape",
    tags: ["机构展望", "目标价", "中长期"],
    views: 14200,
    likes: 298,
    readMinutes: 5,
    content: [
      {
        type: "paragraph",
        text: "在最新发布的策略报告中，多家研究机构上调了黄金的中长期目标价，普遍观点认为金价有望在新的复苏周期中进一步打开上行空间。",
      },
      { type: "heading", text: "支撑目标价的三大主线" },
      {
        type: "paragraph",
        text: "首先，全球进入降息周期降低了持有黄金的机会成本；其次，央行持续购金构成稳定的实物需求；再次，地缘与经济不确定性提升了黄金的避险吸引力。三大因素共同支撑机构对金价的乐观预期。",
      },
      {
        type: "quote",
        text: "目标价是研究的结论，而非交易的保证。投资者仍需结合自身风险承受能力独立判断。",
      },
      {
        type: "paragraph",
        text: "需要强调的是，机构预测基于特定假设，实际走势可能因数据与事件变化而调整。投资者应将研究报告作为参考，而非唯一的决策依据。",
      },
    ],
    relatedNewsIds: ["n1", "n3", "n5"],
    relatedPriceIds: ["comex-gold", "comex-gold-cont", "shfe-au"],
  },
];